/* eslint-disable vue/no-side-effects-in-computed-properties */
<template>
    <div class="mian-container" id="rootConainer">
        <main-header></main-header>
        <div class="main-inner">
            <template v-if="$route.meta.keepAlive">
                <keep-alive>
                    <router-view></router-view>
                </keep-alive>
            </template>
            <template v-else>
                <router-view></router-view>
            </template>
        </div>
        <main-footer></main-footer>
    </div>
</template>
<script>
import Header from './header.vue';
import Footer from './footer.vue';
export default {
    name: 'Home',
    components: {
        'main-header': Header,
        'main-footer': Footer,
    },
    data() {
        return {};
    },
    methods: {},
};
</script>
<style lang="scss">
.mian-container {
    width: 100%;
    height: 100%;
    position: relative;
    background-color: #fff;
    .main-inner {
        width: 100%;
        min-height: calc(100% - 44px - 400px);
    }
}
</style>
